export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.form) {
      this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this), { capture: true })
    }

  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError('needs to be wrapped around a product\'s <form> element')
    }
  }

  async onSubmitHandler (e) {
    if (this.isAcceleratedCheckoutSubmit(e)) return

    e.preventDefault()
    e.stopImmediatePropagation()

    const variantId = this.querySelector('input[name="id"]').value
    const productIdInput = this.querySelector('input[name="product-id"]')
    if (productIdInput) {
      localStorage.setItem(`lastGWPVariant${productIdInput.value}`, variantId)
    }

    await this.addToCart()
  }

  async addToCart () {
    const result = await window.BAO.Cart.addItemFromForm(this.form)
    return result
  }

  /**
   * Wallet buttons (Apple Pay, Google Pay, Shop Pay) must reach Shopify's
   * accelerated checkout script. This form otherwise captures submit and
   * turns every submit into an ajax add to bag.
   *
   * @param {SubmitEvent} event
   * @returns {boolean}
   */
  isAcceleratedCheckoutSubmit (event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : []

    for (let index = 0; index < path.length; index++) {
      const node = path[index]

      if (!node || !node.tagName) continue

      const tagName = node.tagName.toLowerCase()

      if (
        tagName === 'shopify-accelerated-checkout' ||
        tagName === 'shopify-accelerated-checkout-cart'
      ) {
        return true
      }

      if (node.classList && node.classList.contains('shopify-payment-button')) {
        return true
      }
    }

    const submitter = event.submitter

    if (
      submitter &&
      typeof submitter.closest === 'function' &&
      submitter.closest('.shopify-payment-button, shopify-accelerated-checkout')
    ) {
      return true
    }

    return false
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

if (!customElements.get('bao-product-form')) {
  customElements.define('bao-product-form', ProductForm)
}
